{
  "create_new_schedule": "Neuen Zeitplan erstellen",
  "copy_schedule_alert": "Das Kopieren der Zeitplandaten kann einige Minuten dauern",
  "manage_schedule_settings": "Zeitplaneinstellungen verwalten",
  "all_venues": "Alle Veranstaltungsorte",
  "no_venues": "Keine Veranstaltungsorte",
  "x_venues_selected": "{{ count }} Veranstaltungsorte ausgewählt",
  "view_by": "Ansehen von",
  "day": "Tag",
  "venue": "Veranstaltungsort",
  "cluster": "Cluster",
  "no_space_defined": "Kein Speicherplatz definiert",
  "no_sessions_in_view": "Keine Sitzungen in dieser Ansicht",
  "discipline": "Disziplin",
  "day_discipline": "Tag (Disziplin)",
  "day_venue": "Tag (Austragungsort)",
  "daily_run_sheet": "Täglicher Ablaufplan",
  "venue_run_sheet": "Spielplan für den Austragungsort",
  "DCAS": "DCAS",
  "summary": "Zusammenfassung",
  "show_scheduled_items": "Geplante Artikel anzeigen",
  "hide_scheduled_items": "Geplante Artikel ausblenden",
  "show_sessions": "Sitzungen anzeigen",
  "hide_sessions": "Sitzungen ausblenden",
  "error_loading_schedule": "Beim Laden des Zeitplans ist etwas schief gelaufen",
  "schedule": "Zeitplan",
  "save_schedule": "Zeitplan speichern",
  "delete_schedule": "Zeitplan löschen",
  "create_schedule_form": {
    "create_new_schedule": "Einen neuen Zeitplan erstellen",
    "name_field_label": "Name des neuen Zeitplans",
    "status_field_label": "Stellen Sie den Status des neuen Zeitplans ein",
    "status_field_options": {
      "draft_label": "Entwurf",
      "draft_description": "Der Zeitplan ist nur für die in den Berechtigungseinstellungen genannten Personen sichtbar",
      "published_label": "Veröffentlicht",
      "published_description": "Für jeden sichtbar"
    },
    "copy_versions_label": "Wähle die Disziplinpläne aus, die du in diesen neuen Zeitplan kopieren möchtest"
  },
  "create_sub_schedule_form": {
    "create_new_sub_schedule": "Erstelle einen neuen {{ subSchedule }} Zeitplan",
    "parent_schedule": "Übergeordneter Zeitplan",
    "new": "Neu",
    "copy_existing": "Kopie von existierendem",
    "name_of_calendar": "Name des Kalenders",
    "selectSubSchedulesToCopy": "Wählen Sie die {{ scheduleVersionType }} (s) aus, die Sie kopieren möchten"
  },
  "edit_schedule_form": {
    "edit_schedule": "Zeitplaneinstellungen verwalten",
    "name_field_label": "Name des Zeitplans",
    "status_field_label": "Stellen Sie den Status des Zeitplans ein"
  },
  "edit_schedule_data_options": {
    "title": "Bearbeiten Sie die Optionen für Zeitplandaten"
  },
  "add_data_fields_form": {
    "add_datafield_list_items": "Elemente der Attributliste hinzufügen",
    "download_template": "Laden Sie die CSV-Vorlage herunter",
    "upload": "Laden Sie CSV hoch",
    "venue_location": "Standort des Veranstaltungsortes"
  },
  "settings": "Einstellungen",
  "visibility": "Sichtbarkeit",
  "create_session_form": {
    "create_new_session": "Neue Sitzung erstellen",
    "ticketedDescription": "Sitzung, die standardmäßig als Ticket gekennzeichnet ist",
    "headings": {
      "formTitleNew": "Neue Sitzung",
      "formTitleEdit": "Sitzung bearbeiten",
      "details": "Einzelheiten",
      "time": "Zeiten der Sitzung",
      "venue": "Veranstaltungsort",
      "events": "Ereignisse in dieser Sitzung",
      "type": "Stil der Sitzung",
      "entry": "Eingabe und Übertragung",
      "ticketingAndBroadcasting": "Ticketverkauf und Rundfunk",
      "ticketed": "Eintrittskarten ausgestellt"
    },
    "inputLabels": {
      "code": "Sitzungscode",
      "style": "Stil der Sitzung",
      "description": "Beschreibung der Sitzung (optional)",
      "day": "Tag",
      "spare": "Als freien Tag verwenden",
      "sTime": "Startzeit",
      "eTime": "Endzeit",
      "zTime": "Null Zeit",
      "zeroCheckBoxLabel": "Entspricht der Startzeit der Sitzung",
      "estimated": "Voraussichtliches Ende",
      "duration": "Dauer (Minuten)",
      "ticketed": "Sitzung mit Ticket"
    },
    "buttons": {
      "addEvent": "Eine Veranstaltung hinzufügen",
      "addAnother": "Ein weiteres Ereignis hinzufügen",
      "removeEvent": "Ereignis entfernen",
      "addPhase": "Phase hinzufügen",
      "addAnotherPhase": "Eine weitere Phase hinzufügen",
      "cancel": "Stornieren",
      "save": "Speichern",
      "delete_session": "Sitzung löschen"
    },
    "delete": {
      "title": "Sitzung löschen",
      "message": "Durch das Löschen dieser Sitzung werden auch die geplanten Elemente und alle Aktivitäten gelöscht, die speziell damit zusammenhängen. Möchten Sie den Vorgang fortsetzen?",
      "confirm": "Bestätigen",
      "cancel": "Stornieren"
    }
  },
  "summary_grid": {
    "venue": "Veranstaltungsort",
    "discipline": "Disziplin"
  },
  "scheduled_item": {
    "CREATE": "Neuer geplanter Artikel",
    "EDIT": "Geplanten Artikel bearbeiten",
    "within_event": "Innerhalb der Veranstaltung",
    "delete_item": "Artikel löschen",
    "venue": "Veranstaltungsort",
    "space": "Weltraum",
    "time": "Zeit",
    "location": "Standort",
    "delete": {
      "title": "Geplanten Artikel löschen",
      "message": "Bist du sicher?",
      "confirm": "Bestätigen Sie",
      "cancel": "Stornieren"
    },
    "time_type": {
      "not_before": {
        "name": "Nicht vorher",
        "description": "Der geplante Artikel beginnt nicht vor der angegebenen Startzeit."
      },
      "followed_by": {
        "name": "Gefolgt von",
        "description": "Die Startzeit hängt von der Endzeit des vorhergehenden geplanten Artikels ab."
      }
    },
    "estimated_duration": "Geschätzte Dauer",
    "estimated_duration_description": "Die genaue Dauer des geplanten Artikels ist nicht sicher.",
    "save_and_next": "Speichern und weiter",
    "save_and_finish": "Speichern und fertig"
  },
  "session_card": {
    "day": "Tag",
    "start_time": "Startzeit",
    "end_time": "Endzeit",
    "duration": "Dauer",
    "medal_session": "Medaillen-Sitzung",
    "add_scheduled_item": "Geplanten Termin hinzufügen",
    "scheduled_items_in_session": "Geplante Termine in der Sitzung",
    "events_in_session": "Ereignisse in der Sitzung",
    "close_popup": "Popup schließen",
    "edit": "Bearbeiten",
    "zero_time": "Null Zeit",
    "no_space": "Kein Leerzeichen",
    "in": "In",
    "show_more": "Zeig mehr",
    "show_less": "Zeig weniger"
  }
}